import { useState } from 'react';
import { faqs, siteContact } from '@/mocks/gossipData';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr] lg:gap-12">
          {/* Left intro */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <div className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-900">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              常见问答
            </div>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[2rem]">
              关于「昨日吃瓜」<br />
              你可能想问的
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              我们把追瓜用户最高频的问题整理在右边，点开就能看到解答。如果还有疑问，也可以直接写信给我们。
            </p>
            <a
              href={`mailto:${siteContact.email}`}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line" /> 写信提问
            </a>
          </div>

          {/* Accordion */}
          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    isOpen ? 'border-primary-200 bg-background-100' : 'border-background-200 bg-background-50 hover:border-primary-200'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="flex items-start gap-3 font-heading text-[15px] font-bold leading-snug text-foreground-950">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      {f.q}
                    </h3>
                    <span className="shrink-0 text-lg text-foreground-500">
                      {isOpen ? <i className="ri-subtract-line text-primary-600" /> : <i className="ri-add-line" />}
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[52px] text-sm leading-7 text-foreground-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}